import {
  gqlFetcherFactory,
  type OauthProvidersQuery,
  oauthProvidersQuery,
  type ServerConfigQuery,
  serverConfigQuery,
  ServerFeature,
} from '@affine/graphql';
import { Store } from '@toeverything/infra';

import {
  gatedBackendFetch,
  isExplicitBackendRequestCancellation,
} from '../services/backend-request-gate';

export type ServerConfigType = ServerConfigQuery['serverConfig'] &
  OauthProvidersQuery['serverConfig'];

export class ServerConfigStore extends Store {
  constructor() {
    super();
  }

  async fetchServerConfig(
    serverBaseUrl: string,
    abortSignal?: AbortSignal
  ): Promise<ServerConfigType> {
    const gql = gqlFetcherFactory(`${serverBaseUrl}/graphql`, (input, init) =>
      gatedBackendFetch(input, init, {
        baseUrl: serverBaseUrl,
        isCancellation: error =>
          isExplicitBackendRequestCancellation(error, abortSignal),
      })
    );
    const serverConfigData = await gql({
      query: serverConfigQuery,
      context: {
        signal: abortSignal,
        headers: {
          'x-streamlain-version': BUILD_CONFIG.appVersion,
        },
      },
    });
    if (serverConfigData.serverConfig.features.includes(ServerFeature.OAuth)) {
      const oauthProvidersData = await gql({
        query: oauthProvidersQuery,
        context: {
          signal: abortSignal,
          headers: {
            'x-streamlain-version': BUILD_CONFIG.appVersion,
          },
        },
      });
      return {
        ...serverConfigData.serverConfig,
        ...oauthProvidersData.serverConfig,
      };
    }
    return { ...serverConfigData.serverConfig, oauthProviders: [] };
  }
}
